/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M5 4a1 1 0 011-1h1v9l2-1 2 1V3h6a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 000 2h10a2 2 0 01-2 2H7a2 2 0 01-2-2V4z" _fill="#0071B3"/>'
  }
})
